import { render, staticRenderFns } from "./Informacion-legal.vue?vue&type=template&id=5737b27e&scoped=true&"
import script from "./Informacion-legal.vue?vue&type=script&lang=js&"
export * from "./Informacion-legal.vue?vue&type=script&lang=js&"
import style0 from "./Informacion-legal.vue?vue&type=style&index=0&id=5737b27e&scoped=true&lang=css&"
import style1 from "./Informacion-legal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5737b27e",
  null
  
)

export default component.exports